module.exports = __webpack_public_path__ + "static/media/DSC01626.42c750de.jpeg";